/* eslint-env node */
module.exports = {
  version: 'v32',
};
